import { useState } from "react";

let counter = 0;

export function useModalZIndex(): number {
  const [z] = useState(() => 200 + counter++);
  return z;
}
